/** What the helper reads of a key event; a React keyboard event is one. */
export interface ListFocusKeyEvent {
    key: string;
    target: EventTarget | null;
    preventDefault: () => void;
}

/**
 * Moves focus through a list of controls the way a menu does: the up and down arrows step
 * and wrap at either end, Home and End jump to the ends. Home and End are left to a search
 * field, where they move the caret. Returns whether the key was handled.
 */
export function handleListFocusKey(
    event: ListFocusKeyEvent,
    items: readonly HTMLElement[]
): boolean {
    const { target } = event;
    switch (event.key) {
        case 'ArrowDown':
        case 'ArrowUp': {
            event.preventDefault();
            if (items.length === 0) return true;
            const index = items.findIndex((item) => item === target);
            const step = event.key === 'ArrowDown' ? 1 : -1;
            const next = index === -1 ? 0 : (index + step + items.length) % items.length;
            items[next]?.focus();
            return true;
        }
        case 'Home':
        case 'End':
            if (target instanceof HTMLInputElement) return false;
            event.preventDefault();
            (event.key === 'Home' ? items[0] : items[items.length - 1])?.focus();
            return true;
        default:
            return false;
    }
}
